import { Zap, MessageSquareText, Gauge, BarChart3, RefreshCw, Users } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';

const FEATURES = [
  {
    icon: Zap,
    title: 'Generated in Seconds',
    body: 'Upload your notes and a 10-question quiz is ready in under 10 seconds. No templates, no manual writing — your exact material, every time.',
  },
  {
    icon: MessageSquareText,
    title: 'Instant Feedback & Explanations',
    body: 'Every answer — right or wrong — gets an immediate explanation. Understand why, not just what, so the knowledge sticks.',
  },
  {
    icon: Gauge,
    title: 'Adaptive Difficulty',
    body: 'The quiz gets harder as you get better. Our AI tracks your performance and adjusts question difficulty automatically to keep you in the learning zone.',
  },
  {
    icon: BarChart3,
    title: 'Detailed Score Breakdown',
    body: 'See exactly which topics you aced and which need work. Pinpoint weak spots and retry them instantly with a focused mini-quiz.',
  },
  {
    icon: RefreshCw,
    title: 'Unlimited Retakes',
    body: 'Every time you retake, the questions shuffle and new variations appear. You can never just memorise the answer order — you have to actually know it.',
  },
  {
    icon: Users,
    title: 'Challenge a Classmate',
    body: "Share a quiz link and compete live with friends. See each other's scores in real time — a little competition goes a long way.",
  },
];

const QuizFeatures = () => {
  return (
    <section className="relative py-20 lg:py-24">
      <div className="glow left-1/2 top-0 h-[360px] w-[600px] -translate-x-1/2 bg-accent/8" />
      <Container className="relative">
        <Reveal className="text-center">
          <span className="eyebrow">What You Get</span>
          <h2 className="font-heading mx-auto mt-5 max-w-3xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
            <span className="head-fade">Quizzes That Work </span>
            <span className="text-accent-grad">As Hard As You Do</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[0.95rem] text-white/55">
            Every quiz comes with intelligent features built to push your
            understanding further — not just test it.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 3) * 90}>
              <div className="glass glass-hover h-full rounded-2xl p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/12 text-accent">
                  <f.icon size={21} />
                </span>
                <h3 className="font-heading mt-5 text-[1.1rem] font-semibold text-white">
                  {f.title}
                </h3>
                <p className="mt-2 text-[0.87rem] leading-relaxed text-white/55">
                  {f.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default QuizFeatures;
